var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.exibir)?_c('Header',{attrs:{"home":true,"logged":_vm.logged}}):_vm._e(),_c('div',{staticClass:"section"},[_c('div',{attrs:{"id":"wrapper-consulta"}},[_c('FormConsulta')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }